export function Footer() {
  return (
    <footer className="border-t border-midnight-teal/20 px-6 py-8 text-center">
      <img
        src="/kb-blue-green.svg"
        alt="Karishma & Ben"
        className="mx-auto h-12 w-auto"
      />
    </footer>
  );
}
